export const AI_TRANSLATED_LABEL_ID = '4ff1eeea-17c4-43c0-b1b8-d89b25f09ad3';

export const AI_TRANSLATED_RU_ARTICLE_IDS: Set<string> = new Set([
  '11389bb0-910b-47cb-9e7c-c5c177d973f8',
  '581f45f2-22df-43b0-a345-21626967b531',
  '65fbf381-68c0-4470-a31c-d77cba1a5ca3',
  '747cdf8a-cb80-4b9c-bdd1-5f1414bc4da3',
  '7e253c0e-a321-4f07-9e83-8be08a403298',
  'd5515fd8-bce2-481c-a38c-1ebea3f07487',
  'eee04d7f-3235-400e-b69d-cf38a290f792',
  '1becade5-9b45-410c-999b-b6925e875dca',
  '428483aa-27aa-4132-b6c0-f00bab77e18d',
  '5ec60bed-ddf2-46e7-b99c-62960d61907a',
  '60fdfe99-1c92-46a6-aaad-43ac632c5468',
  '6323fef0-3d2a-4859-821a-2efe500b4c58',
  '645e4739-fb15-4966-84e4-a02fbcfb387b',
  '7d21c253-2c46-4423-95aa-4dcd4e79f536',
  '874e26b3-8ae7-4623-a6e5-5657a98eb457',
  'a462b2c5-f694-47e7-a955-01080f81646d',
  'bbced122-dcb5-4209-9907-f2e50068b67b',
  '107823b5-c892-4ca0-b1ef-577119263016',
  '11124879-03b8-42ab-8c88-0d95c8a9e92e',
  '14406194-be82-4307-bb17-197d35a0da65',
  '15bb04c2-f754-4c44-97a7-8de67389f9fb',
  '18f735ee-b53e-462e-b206-4adce65aed13',
  '193a1f05-ac7f-465a-b7ca-a4e5cef591ae',
  '1eb54831-e08d-47a5-8fd7-5efcc9406e2d',
  '21303a62-5fdc-490f-81bf-d7034bcc2fd9',
  '223b47ae-9d10-4b9a-a9ec-2f1e0d7ab613',
  '2549c1e9-97fe-4e10-bae3-303c5c217ea8',
  '284fbe37-01a0-4922-9762-d0941e3ede55',
  '2a710b97-0c6f-4705-a052-44ae749dbb2a',
  '3541cfcf-1764-4aa7-a1a5-e94e3ca2a94e',
  '3759f479-1641-4fd9-be96-256a85d9ea32',
  '41011fe0-f4cc-447a-8632-f9514d7502e7',
  '5c61abf1-0661-4a9e-83e5-10c55a1ad6ed',
  '64801913-0e05-4ff4-b36c-ae90679818ed',
  '676c6ff4-8623-4883-b527-6e54fbb7844e',
  '67ee895a-db8a-495f-a6ed-1cce3c9f4ae2',
  '6c422bdd-ab59-4c14-ba32-018670e802da',
  '6ccafb9e-5ead-4850-afa6-793c3ac111d7',
  '753851ba-4055-41dc-a17d-8dee3921514b',
  '791a5719-fd58-469a-affa-79d767872a17',
  '800d1b00-4c78-4d4a-9155-7039cac81901',
  '85f062c6-cbb0-4336-bec5-637c007e90ca',
  '860dd08c-b62e-460b-a519-120fb26dda6a',
  '873b4b74-938f-469d-9d4c-40fc6810d497',
  '87566686-6bf3-4b46-a1e9-db88000614c8',
  '917fd7ee-fe3d-4538-a8c0-370a302c9fb9',
  'a0b9d29b-65b9-42eb-a7a5-6fb3f2cd408c',
  'a481c0b7-3f20-43d0-88e9-44c6c732ed83',
  'b86cf537-3894-4eb1-9dcf-cc7bfea7377c',
  'be13b4b0-032a-4c9c-aa0c-f4b21ef0c7fa',
  'bf7d9969-0ebd-4190-933f-507c03e9345c',
  'c1226dfc-b21c-4add-910f-2956a7cb47b0',
  'c1c19025-6e6c-454c-8920-8a224315abf4',
  'd7ae7ccd-676d-4fcd-8d94-fdcff7c7e669',
  'd7cd3e7b-6702-4613-9197-bf580cd560d9',
  'dfac1126-f8e9-4f91-a74c-97e441181252',
  'e3a14315-c8e6-4d80-bb92-18a3a38faf72',
  'ea00df43-ec40-4bc8-b676-ff4463a5e317',
  'ed5207f7-0ccb-452e-84c3-f0e1d4fe604f',
  'f3bcef49-ea2b-4b69-a547-e4977455f5e9',
  'f3e95690-e2c0-4172-bd5f-f6b77335279d',
  '0204d706-a79e-48da-84b3-fbbddc22d5e1',
  '05add005-bfbb-4dd7-ad99-d48a67778beb',
  '0eb2f0fc-21bd-421f-a767-c913ae720905',
  '10c4b028-0331-47ae-acf4-33bd3275d82c',
  '1115ea4f-0164-46e3-b79f-0a42c53254d6',
  '1512e7fa-c30b-4209-b84b-8098a1aecc9a',
  '159a968b-af00-48ee-852d-767e3461fb7a',
  '212ee303-94cd-4d44-9df5-7a8df9bc96cb',
  '2c54321d-26ed-4570-bf82-bb1ee5182e56',
  '300f1ef6-36e6-4903-97d9-9faeb97c6e38',
  '32d95c37-4291-4286-a2d5-9bf33fa3e0f7',
  '331a0226-5928-4951-8c89-4ba0612d1039',
  '39e06cb3-4529-4ea6-8874-f8230b6c1628',
  '3f0d472a-c729-4896-9b62-213993a8b9d3',
  '3fcd94c1-1bd4-4211-957f-474129e5954e',
  '45f1253b-1b70-4e49-aca6-c8edd87400d0',
  '4d7ff63f-6261-4621-97dd-b391dd203833',
  '4ff84052-7bd0-4418-bd33-dfbb78bf9940',
  '508ea2cb-7ea0-4017-b259-8d0d46af2801',
  '5ccfd801-c41c-416d-b33b-697e759ce8cc',
  '61e789e4-fbde-42df-8a14-25bc26e88998',
  '634e6672-89cc-400e-b241-19a85624c352',
  '6382ed9d-6a5f-4a47-962b-c5c202752244',
  '6432eb14-5529-407b-ae7e-f7215c8e3ea0',
  '643f64e0-0c41-48dc-97a4-08996301ddaf',
  '67f7c21b-a229-44b9-9444-6aa8c600be93',
  '68dfc0f5-8625-4861-bc16-c35675755bd0',
  '69a1d1cd-81f8-4c58-88cb-7b81eea54e60',
  '69a2c058-3724-4f54-a6d2-c1d697da010d',
  '726ca486-7384-41e0-8f15-09da403a86e3',
  '755bb0a9-9f16-4902-9780-9a99013c15ee',
  '76de0b46-6155-483d-a098-e3869fab9ece',
  '79b85027-87f6-45fa-8db6-d3a4d1c9db4e',
  '80aa6188-7cc9-4710-92cb-c3847d0f23e6',
  '8343f20c-f236-41fd-a5d5-b964e21cd579',
  '86eb5da2-72ad-4594-94e4-5a557d4263f8',
  '8b110206-b127-4034-819a-0eb678989fa0',
  '93844adb-06b3-4475-be27-86414c8f8601',
  '99fe9ea9-3b51-450f-8fdb-39c5813a993a',
  'a95936d4-7f1b-4068-bf7e-b4d15ef777c8',
  'ab308a40-ed8e-463d-af49-efe868ae219d',
  'b0de68dc-90c7-4032-8609-1aa35dc50b57',
  'b37b816c-b4b0-4acf-b5a1-445184022aaf',
  'b53042cd-5a1d-4d63-86a7-e09367a89e7b',
  'b62a76a9-8fad-4858-944b-810bfd7a8990',
  'bb28abbf-3f69-4209-8097-9e9863c92215',
  'c1f52323-b781-43ba-937f-36a9439cf746',
  'ca3c42af-4775-42e4-92d5-8828539c6179',
  'cefdfa29-6792-48fe-a077-ca7bd230d769',
  'd046f464-f5f0-44fa-9d23-d2cfa295faf8',
  'd4107177-08e7-4d84-a23a-ca0489f991dc',
  'd7a49ad8-8135-4b01-a858-582ad34875c6',
  'd7f7f130-e262-4d6d-a326-fb6391187438',
  'dc03ebe4-9630-4bd0-9c33-40cbbd4b6557',
  'e12528d1-d1ab-42c7-9251-5424dd0a4ede',
  'e5b32278-325f-43bb-bada-047c6724b0fe',
  'e7b449fb-1d92-430e-9ce3-56e0aaaf6bee',
  'e9427114-64cf-4866-8b36-0d7558bff394',
  'edd6df77-c8b6-4fc9-9167-f090d9208cad',
  'ef52b20c-0549-49dc-9e69-a4371b7fee11',
  'f64bc156-34f4-4049-8245-4ba9c8b729bc',
  'fc002f20-e3ef-47a9-8d7d-d4f1a9ad66e1',
  'fc626224-171e-4c9a-a502-b5a3c48cd3e2',
  'fcea264b-9c44-449c-b4dc-abe32bf066b5',
  'fd708f5c-0b9c-4b42-b921-97408403d012',
  'fda33f82-dfc0-4c6d-a7d0-2630b362f395',
  'fe1be3cc-c0ee-435e-9c29-5424fea16d03',
  '035dd136-6e03-407f-8fbd-5afccebc8a28',
  '04efe61a-18d0-441e-8b9a-adb648b904db',
  '06a33cd6-44d5-470d-a9a4-434b92a9ec0b',
  '11404d67-0fa2-4f00-9675-53bd9765c196',
  '16a10bc8-f6e9-459f-8cdf-e5e8b03d26cd',
  '328e4e6c-72fa-409e-ae0a-186d1407a8b1',
  '38545ed1-2d9e-4300-b7b7-0a457835f797',
  '4689387e-24c6-486e-8c9d-4d0735be5724',
  '468c6761-a829-4916-9797-41602325012c',
  '47d9d70c-a840-4512-9833-7b8fdfe4336a',
  '4bb478d9-c704-4fad-a886-7f188983b446',
  '66ad87dc-79b4-450c-b7fd-a4ebeba4c2ea',
  '6d369e9a-b814-4e3e-b31c-f081b6903bbc',
  '72c6b22e-2b8d-427f-94ec-df115e8d0a08',
  '7345b00e-d460-4e97-b70b-13ca0409799d',
  '81f95b8a-d898-4939-9c16-1cff03a06131',
  '8245ff45-6336-43e4-a269-9cd34cd45db0',
  '899238e0-9bbd-4e11-b49b-2875136b82a2',
  '8b371c7e-d52a-4e78-a734-0ee7e387da4c',
  '973055dd-e39c-4ca3-b34a-0a7b62556586',
  '98e6cff3-dd22-47da-9041-5e93bfb215d7',
  '9b84c729-8de5-4783-b26f-a35d7a904e69',
  'd5037606-ff03-4ae2-af75-c6832472173b',
  'dc0e7238-0b18-42f5-b84c-66c6c915ee11',
  'e02e4201-88db-46a2-943c-0acc036f2df9',
  'e32c82a2-b688-4c22-8af5-b0dc4a2382a2',
  '0d7ea9b2-24b3-4823-97b1-f8d36694dd71',
  '28d400bb-9d4c-4241-8121-a3ace7705849',
  '3f0424cb-77fa-41a9-8b16-cd7745674827',
  '44791faf-be04-47b9-abd3-e3dade20cf12',
  '4672be2c-9868-4668-955b-14bc3ba8627d',
  '66319c0a-4a65-4eac-a4a0-982312e70575',
  '716ff7a2-d658-44e2-bd5e-0517a96b81e6',
  '7970fbe7-942d-40b8-970f-951ba3f939f7',
  '8dbd31f1-4da5-4b2b-a91c-085a933d7a9b',
  '9e218ef3-0227-41c9-9d68-908bc1ab466d',
  'a4da13c0-85c3-4a14-8fac-f5622915d951',
  'b0a8984a-f378-4a57-8baa-9ce48703edea',
  'c8068a3d-a5ad-44dc-9f55-ff3761329d7e',
  'd1a67750-4869-4157-bedd-b14db51a77ad',
  '090593c5-e2d1-490c-9742-4f811a8c01bd',
  '2d9fb141-61ac-45e6-809d-a8f178c6c1bc',
  '552eb551-dd0b-4cdf-b47f-55d01da63745',
  '5a4d8f1e-5880-4ecc-95e1-52aaa98eb54b',
  '5e4046be-7345-4418-9b06-45d52d51731b',
  '7af3d62a-1d85-484d-b2f4-7d166ca45911',
  'afef8051-6f6f-4e23-bc81-f4b05ffef6b3',
  'c04fc49b-8e73-47b0-9dce-b0750713e1ef',
  'c614e1b9-bc1b-409d-942f-0e865ecf3b74',
  'cc056765-3f31-49cf-843c-93f777fd95f0',
  'd7b8660b-acc8-4879-a662-7831ed875fd8',
  'db200e7d-5f88-4392-b380-6bb76cd3aa8b',
  'e253951f-b0a3-4c88-aae5-2796eb72dc83',
  'ecf4f907-c244-48f4-8510-e314a24c4a16',
  'fd42fac1-afde-4f52-880f-71c0dccf1f83',
  '4d9ca02b-e4e5-47e0-90ac-7e44154ed3e8',
  '5a261322-6d86-46ae-a3d1-5b6c53a0f769',
  '5c9c44f6-8fdc-4ade-a7e7-c7b6a0d1b9dc',
  '674d7454-b62d-4d3a-8a53-ff75b308ad3a',
  '4778c0cc-244f-432e-bf98-372ff06715d4',
  '4e507b9e-dfc3-42a2-b11d-69ea9c965d29',
  '060a15da-3389-4287-9844-9c68574cb9a2',
  '1a1f9b6d-e964-4442-8b67-b3256945dd01',
  '2ac8f72c-73c0-482e-ae70-1e400e12b278',
  '519e1365-3b67-4ecf-87a6-db545e332109',
  '5c51faee-62f1-4ba4-8c8b-a5beff4fb7ed',
  '5dc06dfe-632a-449b-93ce-98e1bbdee547',
  '63e0da86-ae41-4461-85f3-2d72da9300de',
  '6c7d1e91-a8a9-48fb-b203-a731a11e6cc7',
  '71e41bf3-dec7-4642-8979-bec7e34f3fc6',
  '87cd33b0-5afc-4210-8f80-7a4ab6940fff',
  '8f810172-7959-4348-bc43-e7afae6a1c30',
  'bb18ee08-6697-4854-8344-9676915cb4a7',
  'bb3bb63a-9cf2-4176-b9a7-27cd1d0bb1ef',
  'c93f79c5-75a8-48e1-80b5-082fab451192',
  'caadd780-817f-4c77-b020-5670ae1124e6',
  'd161df5b-a443-41e5-b805-9777f5e31b0b',
  'd41ba83a-d9b2-4cf9-acae-fc75a67e2e59',
  '4dedc42b-a48e-40c7-81d7-7ed280c0e29b',
  '8005bd42-3f4c-4373-b873-613044da21f9',
  '87838611-aa38-4faa-95cf-73f281a411a9',
  'bb419a8d-3842-4ecc-87ec-608841f0921c',
  'cf311495-b958-40e3-a74e-a1d3e58d5458',
  'd2acb7ba-2bd6-428b-86df-0b57cb76ca13',
  '46457ad6-8452-4747-805e-07cdbc2cf4d3',
  '5e032705-826b-410e-a593-de66fc3f7b41',
  '788c8e43-1240-40b4-98b3-3a1f74646eac',
  '8efa0d8a-82c8-469f-b0f2-cb02dc360f2d',
  '9179026a-75ba-406f-9155-b79e640f8878',
  '92f9c2df-c2e3-4a73-8dc7-859ef3f244e4',
  'c5287b7f-9332-465c-99d5-6f4474c2baab',
  'cb330e37-30a3-4159-9ebb-fada76b5c89b',
  'fe5ed784-71a2-4997-b947-493ad1e65cf5',
  '05376feb-ff16-4259-bc3d-1fb2176930bb',
  '1985852b-45ad-45f3-a912-1a686488fe23',
  'bb44621b-8529-4a69-b004-ad7b1c709e62',
  'dba7ced4-3a8c-4ada-9ff2-bfa693227c5d',
  'fbf10535-1796-42e7-9429-4b335c6ece7b',
  '40dd2c29-7626-499c-9844-182e9375832e',
  '9c34f458-465e-4065-8d71-cbeccd726e4f',
  'ad663b4c-3c3c-46ab-bd35-4c65c589f37b',
  'bf0f82d2-673c-4fe7-9ba2-05558ebc5b93',
  'c636ae2a-95ab-4273-b69a-700ae3b48f9b',
  'dd2f7fa8-47ff-419e-855b-de08c49969cd',
  'ea9926d0-6812-48b1-974f-17ef869ce7df',
  'f21e9aad-90a6-4f09-bb2b-e13e59d9e2a2',
  '05e86abf-d995-4c89-80a5-d03c60041102',
  '22b018bc-034b-4d70-ab72-e5561f805de4',
  'faf779e8-cb45-411e-af9d-65d1effc23bc',
  '5e887cbb-d670-4885-a215-b6fa64ac9eb2',
  '8114b74d-980d-4444-8533-c990a39081c1',
  'd1c6cfad-bc8d-46d2-9815-6827d8770957',
  'df7ab1d7-4180-4524-8a6b-75332e96dcd7',
  'f1a9f38c-eed7-4d8c-9d27-ed81458ec4d7',
  '10221427-1d35-47e9-b6b1-e4fd8382bb2f',
  '4db2adda-2d6d-4ff8-b02b-ada132f2a712',
  '96d0051a-7106-4bb2-b665-18a587498238',
  'ac3e7083-c836-419c-9749-fa85e4144c6f',
  'bb120b62-9a5a-4575-836c-645a8cc25771',
  'bef5ef0a-fae6-4d37-8138-4169e64ee6fb',
  'c790142c-344c-4c44-b736-0b065fdfe0e4',
  'e4d3077b-9d75-4b27-8da9-1cde3ed66a95',
  '2717145f-cbd0-4029-87d0-92ce076ec038',
  '37f24ed5-d682-4c2f-92ff-b8336c0e9afc',
  '38b1273f-4c23-4576-aeaa-9c02193d638c',
  '38cf053a-5172-4bfb-a6e5-7aad25bdeef9',
  '59e9a90a-d80a-450d-a517-d77475d2eafc',
  '5e51550e-4cff-4536-925f-dec69a5d33e9',
  '8a535ee3-4692-4b05-b6be-ff02f5c26360',
  'e9fe0491-7ebf-4f3e-9ecb-8e34cb4f944b',
  'ff5d3921-6449-4725-989a-cbe0ea0d0323',
  '1ed68068-a312-40f2-b3a4-50a05f4babde',
  '2d6728ff-d0c3-4155-a8ca-11f80ec991fb',
  '51b5682a-e5c2-465c-abb9-dc345e1a3d6b',
  '5b1ea813-00f4-405a-9855-8c634a0d627f',
  '5ed4f2e6-ba48-4f92-8537-39b3be7eed23',
  'c5653059-22fa-45a4-a14d-d77e35e2307f',
  'cd50fd11-3513-42ff-88d0-18edbcd0642a',
  'cde8586a-ccce-4a80-9828-ed8bdceadf7c',
  'd3f6c726-ef0d-4f25-a712-e5a587b28b12',
  'f6970c6e-a136-49e9-9e8b-0e526d585130',
  'f9963864-a37c-4367-84e3-f9f249311327',
  '06e28a0a-2230-445c-8ac1-c36329c9d790',
  '0bf556df-3631-4402-9ba5-4742a00f4308',
  '4532f9f1-78de-411e-8783-fc6f734463d2',
  '490cac7a-ca93-4016-86c3-32fc6f8afc57',
  '59c87f88-c708-43e0-987d-8acf8ef8132e',
  '5ce05331-cb4b-498e-bb08-39fa9ddb155f',
  '5ef4683b-083d-4439-a72c-26ab71f929a9',
  '83fb405a-ef5d-4f93-b8a3-6ee86278ec65',
  '84b6d093-8670-42a4-a1f0-c0117a0bc790',
  '8c765681-86a7-4a89-85d5-13d367d468da',
  'a0b399d9-c15e-4255-a62b-22c94516e6ea',
  'b06ed79d-7f1a-4203-a778-b945837db0b1',
  'b7815cf8-a9fb-4e4d-86e8-6a2c553d701e',
  'b810d706-3853-4672-b271-742d035d0855',
  'e626a84f-41b8-4efc-a66a-c44276412f07',
  'ebf7a849-1e6a-406d-8bb0-f9cf5f2fa230',
  'f3e74f18-30a3-4cfc-82c9-9838b941efd9',
  'fbe9b583-274e-444c-bb3f-a4fba2c01226',
  'fe086509-465d-4552-842a-bb8e4830ed11',
  '679ea4c0-e5b6-4afd-a686-2cb04e107cf9',
  '24633ca0-17b9-46a6-901f-5f7c4215d78f',
  '972dedef-2a66-4eed-9810-ee02e6d06d9d',
  'b9ec2026-c1ea-4af6-839c-d690fc453aa0',
  '10a0f141-6981-483e-bda7-536630bb4582',
  '110025d1-d99b-443a-a354-45ec9b9962cc',
  '16a65cfb-d58a-499e-aa73-536c5e8a309e',
  '20e79675-b429-479c-a273-0f9dfc2cc5c4',
  '2344a7f0-75a3-49fe-aa33-482872e62d7c',
  '2720c4d8-16b3-4218-9075-c1ecf388c9b9',
  '343e0621-2a5a-452c-8638-2b6ebafb58ec',
  '75ca708d-9655-4105-8acc-30d57e17215d',
  '78ddefd8-1932-477a-b47c-9ac48819c53c',
  '79c517ed-b192-4489-a02f-1984ea443b17',
  '7be273eb-1c36-4689-9608-d7bde58f826a',
  '8f77767a-6dc3-49b1-9324-eb43e1a63eb9',
  'b13433c3-45d5-480c-914a-124543c6d840',
  'bd965c24-9b3a-48e6-b42f-12fea099b284',
  'bfc397b5-4e7b-4c68-ba22-d2b0f9bbfbdd',
  'c5190146-d7a4-47c6-8fa4-9a08fe311908',
  'dbf2fcb5-c5a0-4b87-ac43-8a3e292a031b',
  'e0e330dc-ead2-4d5c-bcfb-e5b254c01622',
  'e3cfd8ff-6bb3-4366-8e2d-70550dcba789',
  'ecfc3e11-584e-491b-85e9-2799656d287c',
  'ee93baf7-1023-499d-be55-655c6f54f149',
  'f3b137cd-3a4a-4ec5-96aa-444cb9b43daf',
  'fe959c50-439e-4f8d-91cc-a0ff9ca2c0df',
  '3bd418af-1f88-499f-b050-5f0c00b89eaa',
  '73ae207f-81de-4c5a-83a0-e998b4f83653',
  'a1cedc92-d3f6-4937-a0b5-4387abb463e0',
  'a391c2dc-38b7-4c8b-bb7e-0e5cd4c40040',
  'ad7b561b-a9bb-42fa-accc-478fa59dd9cd',
  'f0b4a24e-494e-4e79-83f3-e08b1bc6ee8a',
  '0cf052bc-8ac3-420e-aa4d-537c7f7f4371',
  '1f504978-128e-4c15-8e38-dc0f42bb931d',
  '30ce77fa-7432-442b-9dc7-845d7e83d359',
  '36aaa80e-b01f-414d-aa30-05db1ac7f026',
  '38961584-edbd-4795-8a23-b595bbd8fafd',
  '4b1d10bf-4d5c-4129-bfc3-a7781e844e28',
  '4e5969e1-3d6f-42f1-a203-47da85dd58da',
  '51dd0c88-bd31-4986-9698-4f7745a12fc3',
  '58434171-9461-4e47-9529-0d2557aa2dd2',
  '6975fb2e-27dd-4e9c-8365-de48f70e9107',
  '69970314-f481-4e27-b364-3313fc477aa2',
  '71342d54-5f66-4f42-a177-5e4451daee5e',
  '71e77dd0-3f6f-4b15-82f5-2f8de5628baa',
  '803e8e12-6b0c-42ca-88d5-d77cedb6a922',
  'a18bea24-a19a-4bec-9bae-decb041bd370',
  'b041fadb-3280-49e9-9859-b1b7a15d372b',
  'b6508885-dd41-47bb-b37d-bad3da09add3',
  'b69d93bd-3d38-43d3-b81e-868e38d213a9',
  'b971f1f7-64a3-46a8-b5c3-3576b07c89ff',
  'c13bbf66-54f4-4c3a-8b41-1a6992a7da9f',
  'cbd86429-f64d-437e-b47c-33a4fc9cc592',
  'e0889788-9e4b-4a54-816f-65099c54bf8d',
  'f22fbb52-ad5f-4e1f-a36c-06849afb390c',
  'f7765dfd-2100-4a9b-b185-b38abbc11045',
  '04a5405d-efe6-4c22-9192-482b2b6b5ab7',
  '04cb8274-0342-429c-9c9d-165ca11bf72e',
  '18769520-f6a7-41fb-afa1-dbef4e71e829',
  '199efcc3-a65c-4f6f-aa0d-c5b8d9189ef0',
  '3ae2534f-3231-46b0-80d4-1a3a53db6bc8',
  '40f71ebd-9ec3-4bc4-a0fb-0c1e23af4999',
  '418a0205-c93d-4819-881b-c1df71523804',
  '49835cbc-f166-40a6-9c80-1b8d5c288228',
  '5935b8dc-2cf2-4c7e-a8e2-b4738cf88d5e',
  '5a667fcb-f772-41e0-9a65-7a580a12ba4b',
  '625aa582-282a-48fc-8bd4-23a44778d70d',
  '657d4a47-c0b8-4357-9095-5a9870decd71',
  '6fc6c830-81d6-4383-b651-e0749724835d',
  '7684578b-d351-4a9d-8cd5-d7c2c6ba2750',
  '7ab15b5f-e8a7-45bd-b031-19b27ad9fc94',
  '94cdb162-395b-47c0-b909-6c418f02d4f1',
  'a1f1084e-6d28-497b-8848-39ccc22be7e7',
  'a7e44855-2e2a-4f0f-b69b-fdb2e618d55a',
  'acefb588-7980-431f-a2cd-8a37419fa7e7',
  'b0320684-4c62-48ab-9f55-d9b15a9964b8',
  'b24c6edf-8b8c-412a-ae04-e7adb8c81a4c',
  'ba64437b-cd81-4c95-b81e-0b83b725bbad',
  'bb67af69-7c55-45a6-80db-94b92488a73f',
  'c048f896-81bd-4d10-a26a-b41a23846e3f',
  'c5746429-de2a-4fbd-ba7a-8c3ba212400d',
  'd23e7202-95b4-4a9f-aa05-8ebe6d36beed',
  'd6e898eb-e038-4f2e-8012-cc250e824af6',
  'd76f7de6-b8ba-4182-9eef-52cd1e7c7b57',
  'e74bafee-f562-4ecf-9228-11d62569d4a4',
  'e900d382-1e0a-4f30-a55f-38dfe66aa319',
  'eb3cc6f9-85f0-4312-98c7-2ed2e0b81750',
  'f22040be-0e21-4ad0-a379-d6b8013e098d',
  'f2e4c779-f7e2-478b-a1b2-6532fc9621d9',
  'f9bf3bd3-335d-4486-9d18-d736f66bfae4',
  'fa24ab41-4c4b-45f5-a02b-44a747cf5924',
  '0838f3c0-8d37-4a03-9133-95074cf63313',
  '0dffe61c-d6f1-4859-a242-9f2a1aa15988',
  '1f1b505c-503c-4c5c-b773-c501777bfdc1',
  '26ca4db4-1306-4913-9f62-81758482380f',
  'a7e2b531-4504-45e8-ae52-3f42bb35df27',
  'b98fe06f-00dd-42d8-b05f-f8455c208c43',
  'dbe941c0-2579-41da-9968-7a8dcdd7e9c4',
  '089c8346-117c-407d-ba9f-c756f40fd9cb',
  '35081a1c-0c24-408e-b5fb-dc2b265866f3',
  '40cfe166-383a-4264-8bc5-1a51825a4e60',
  'f9e79f5b-2e84-4c43-8501-562c03a7feec',
  '6974fc0b-0ba3-46b3-a8ea-b1579e6a9243',
  '01a64e56-0cc2-4313-a824-a26eb9683a1a',
  '0dc8b04d-8d87-40dd-87cc-afe5fee27f68',
  '0e60b20d-d977-4954-bdf7-fead824c9931',
  'aa33d7a5-6f2a-4046-9534-310d1f9f60b4',
  'c6c7c9b5-91f6-4436-a872-c2b554a43c74',
  'dfea5d4c-762c-4e19-acc3-c9aa4cd5a900',
  '6de72b6b-c5ba-4a07-95a2-2218c22cf215',
  '02e86438-5ea2-4f64-86ee-7fb7065e24b4',
  '0a12a2e8-9d0e-4d2a-9f35-115854d84aa8',
  '2bd3ad11-f4dd-4cb8-bc0a-bb927ce4a514',
  '599715cc-79cc-4188-9c3f-f9e4edca7552',
  '65378616-a968-4cb3-9bbc-82f4ff76d55a',
  '6739ac82-576f-4346-8697-67229e3a49ce',
  '6d249c7f-e14f-4a1b-9c90-eee09020fab1',
  '8acc68da-f177-49e2-a5c0-9318291fe345',
  '91cbfaaa-4bdc-4632-81ad-ca2507206387',
  '977972fc-0954-4485-8b4c-6423695e7949',
  'ab4fd7cf-21f1-465c-aafb-63e0ffc71bb2',
  'add078b6-7a61-4ae9-a573-210a247f66c6',
  'c8bf0384-d2b6-491d-b085-f8941e3cb81b',
  'cfb78b3c-656c-42b4-bc57-87140b2e309f',
  'd3854807-2b06-4a7c-9318-a764a5264577',
  'ec42fdbe-36f9-4591-a217-0124702aa405',
  'fc22f5e9-77aa-4a7f-a944-a8349dd843ce',
]);
